import { breakpoints } from "@gigpro/ui/utils/useBreakpoint";
import type { ForManagerLocationDetail } from "@sidegigllc/api/client";
import { queries as networkQueries } from "domains/connect/containers/Network/queries";
import { queries as prosFullQueries } from "domains/connect/containers/ProsFull/queries";
import type { ConnectSearchParams } from "domains/connect/routing";
import { queries as groupDetailQueries } from "domains/pros/containers/GroupDetail/queries";
import { queries as groupListQueries } from "domains/pros/containers/GroupList/queries";
import type { WarmableQuery } from "routing/warmQueries";

// `allSources`: the one-kind-of-group flag is on, so the group lists are warmed under the key the containers read.
type QueriesInput =
  | { tab: "pros"; search: ConnectSearchParams; location: ForManagerLocationDetail; allSources?: boolean }
  | { tab: "groups" | "groupDetail" | "network"; location: ForManagerLocationDetail; allSources?: boolean };

export const queries = (input: QueriesInput): Array<WarmableQuery> => {
  switch (input.tab) {
    case "pros":
      return prosFullQueries(input);
    case "groups":
      return groupListQueries(input);
    case "groupDetail":
      return globalThis.matchMedia(`(min-width: ${breakpoints.md}px)`).matches
        ? [...groupListQueries(input), ...groupDetailQueries(input)]
        : groupDetailQueries(input);
    case "network":
      return networkQueries(input);
  }
};
